import { Controller } from "stimulus"

// Connects to data-controller="chat"
export default class extends Controller {
    connect() {
        this.element[this.identifier] = this
        this.scrollToBottom()

        if($('#chat_boot_room_message').length !==0){
            document.addEventListener("turbo:submit-start", (event) => {
                console.log("Turbo form is submitting!", event.target);
                document.getElementById("chat_boot_room_message").classList.add("disabled");
                document.getElementById("chat_boot_room_message").classList.add("text-center");
                document.getElementById("chat_boot_room_message").setAttribute("disabled", "true");
                document.getElementById("chat_boot_room_message").value = "";
                document.getElementById("chat-boot-loader").style.display = "block";
            });

            document.addEventListener("turbo:submit-end", (event) => {
                console.log("Turbo form submission completed!", event.detail);
                document.getElementById("chat_boot_room_message").classList.remove("disabled");
                document.getElementById("chat_boot_room_message").classList.remove("text-center");
                document.getElementById("chat_boot_room_message").setAttribute("disabled", "false");
                document.getElementById("chat_boot_room_message").value = "";
                document.getElementById("chat-boot-loader").style.display = "none";
            });
        }
    }

    scrollToBottom() {
        let height = this.element.scrollHeight
        this.element.scrollTo(0, height)
    }
}